import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from 'react-i18next';
import { addCompanySettings } from "services/CompanySettings.services";
import {
  downloadTemplate,
  getTemplatePreview as getTemplatePreviewService,
  getTemplates as getTemplatesService,
} from "services/Templates.Services";
import { getRegisteredUser } from "services/User.services";

import { queryClient } from "utils/queryClient";

export function useCompanySettingsDialog() {
    const { t } = useTranslation();
  
  const getTemplatesQuery = useQuery<any>({
    queryKey: ["templates"],
    queryFn: getTemplatesService,
  });

  function useTemplatePreview(templateId: string, languageId: string) {
    return useQuery<any>({
      queryKey: ["templatePreview", templateId, languageId],
      queryFn: () => getTemplatePreviewService(templateId, languageId),
      enabled: !!templateId && !!languageId && templateId !== "100",
    });
  }

  function useCreateCompanySettingsMutation(setIsOpen: any) {
    return useMutation({
      mutationFn: addCompanySettings,
      onSuccess: () => {
        setIsOpen(false);
        queryClient.invalidateQueries();
      },
    });
  }

  const getRegisteredUserQuery = useQuery<any>({
    queryKey: ["registeredUser"],
    queryFn: getRegisteredUser,
  });

  const getDefaultTemplateQuery = useQuery<Blob>({
    queryKey: ["defaultTemplate"],
    queryFn: () => downloadTemplate("1"),
    enabled: false,
  });

  const languages = [
    { label: t("settings.companySettingsDialog.languageBosnian"), value: "1", code: "bs" },
    { label: t("settings.companySettingsDialog.languageEnglish"), value: "2", code: "en" },
    { label: t("settings.companySettingsDialog.languageSerbian"), value: "3", code: "sr" },
    { label: t("settings.companySettingsDialog.languageCroatian"), value: "4", code: "hr" },
  ];

  return {
    getTemplatesQuery,
    useTemplatePreview,
    useCreateCompanySettingsMutation,
    getRegisteredUserQuery,
    getDefaultTemplateQuery,
    languages,
  };
}
